
<app-breadcrumb [title]="'Заявки за Услуги'" [items]="['Услуги']" [active_item]="'Преглед на Заявки'"></app-breadcrumb>
<ng-container *ngIf="isLoaded">
  <div style="display: flex; justify-content: end; margin-bottom:10px">
    <button type="button" class="btn btn-success" (click)="openTaxSettlementModal()">Създай Разпределение</button>
  </div>
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col">Заявител</th>
        <th scope="col">ЕГН</th>
        <th scope="col">Отговор</th>
        <th scope="col">Име</th>
        <th scope="col">Тип</th>
        <th scope="col">УРИ</th>
        <th scope="col">RNU</th>
        <th scope="col">Доставчик</th>
        <th scope="col">Доставчик такса</th>
        <th scope="col">Посредник</th>
        <th scope="col">Посредник Комисионна</th>
        <th scope="col">Метод за Доставка</th>
        <th scope="col">Дата на Доставка</th>
        <th scope="col">Разпределена ли е Сумата</th>
        <th scope="col">Статус на Меу Обработка</th>
        <th scope="col">Дата на Заявяване</th>
        <th *ngIf="isGlobalOrg()" scope="col">Тенант</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let service of services" [ngClass]="!isSelected(service)?'':'selected-cell'" (click)="onSelected(service)">
        <td>{{getRequestorNames(service)}}</td>
        <td>{{service.egn}}</td>
        <td>{{GetResponseType(service)}}</td>
        <td>{{service.deliverService.title}}</td>
        <td>{{getServiceName(service)}}</td>
        <td>{{getURI(service)}}</td>
        <td>{{service.rnu || 'N/A'}}</td>
        <td>{{service.deliverService.serviceProvider.serviceProviderName}}</td>
        <td>{{service.serviceProviderTax}}</td>
        <td>{{getAgentName(service)}}</td>
        <td>{{getAgentComission(service)}}</td>
        <td>{{getShippingMethodName(service)}}</td>
        <td>{{getDeliveredDate(service)}}</td>
        <td>{{isSumTaxSettlement(service)}}</td>
        <td>{{getTranslatedStatus(service.status)}}</td>
        <td>{{getDate(service)}}</td>
        <td *ngIf="isGlobalOrg()">{{getGlobalOrg(service)}}</td>
      </tr>

    </tbody>
  </table>
</ng-container>
<ng-container *ngIf="!isLoaded">
<div style="text-align: center;">
  <div class="spinner-grow spinner-grow-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
</ng-container>
